// extracted by mini-css-extract-plugin
module.exports = {"warning":"styles__warning___1TBT7","icon":"styles__icon___1pnZ6"};